module.exports = __webpack_public_path__ + "static/media/hillshade_prepare.vertex.1235f57a.glsl";